// extracted by mini-css-extract-plugin
module.exports = {"connected-user":"style_connected-user__3jZeb","copy":"style_copy__2XMRV"};